import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function LedgerLogoMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 29 24" fill={color} style={style}><g clipPath="url(#prefix__clip0_1244_52272)"><path d="M.715 17.185V24h10.37v-1.511H2.226v-5.304H.716zm26.059 0v5.304h-8.86v1.51h10.37v-6.814h-1.51zM11.1 6.815v10.37h6.815v-1.363H12.61V6.815h-1.51zM.715 0v6.815h1.511V1.51h8.86V0H.715zm17.2 0v1.511h8.859v5.304h1.51V0h-10.37z"  /></g><defs><clipPath id="prefix__clip0_1244_52272"><path  transform="translate(.715)" d="M0 0h27.57v24H0z" /></clipPath></defs></Svg>;
}
export default LedgerLogoMedium;